import React, { useEffect } from 'react';
import { LearnMoreContainer } from 'src/components/v2/learn-more-container';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useAnalytics } from 'src/hooks/use-analytics';
import { SegmentEventType } from 'src/types/segment';

import { Dialog } from '../dialog';
import { NonStandartLearnMore } from '../non-standart-learn-more';

interface Props {
  onCloseAfter?: () => void;
  isShow: boolean;
  onClose: () => void;
}

export const PopupNonStandartLearnMore = ({
  isShow,
  onClose,
  onCloseAfter,
}: Props) => {
  const logAnalyticEvent = useAnalytics();
  const { currency, publicKey, installmentsCount, selector } = useAppContext();

  useEffect(() => {
    if (isShow) {
      logAnalyticEvent({
        event: SegmentEventType.LEARN_MORE_POP_UP_OPENED,
        publicKey: publicKey ? 'yes' : 'no',
        merchantIntegrationType: selector ? 'snippetAndPopup' : 'popupOnly',
        planSelected: installmentsCount,
        popupType: 'standardWithoutInfo',
        merchantCountry: COUNTRY_NAME_BY_CURRENCY_MAP[currency],
        integrationType: selector ? 'native' : 'custom',
      });
    }
  }, [
    currency,
    installmentsCount,
    logAnalyticEvent,
    publicKey,
    selector,
    isShow,
  ]);

  const close = (action: 'cross' | 'inactive zone' | 'continue') => {
    logAnalyticEvent({
      event: SegmentEventType.LEARN_MORE_POP_UP_CLOSED,
      publicKey: publicKey ? 'yes' : 'no',
      merchantIntegrationType: selector ? 'snippetAndPopup' : 'popupOnly',
      popupType: 'standardWithoutInfo',
      merchantCountry: COUNTRY_NAME_BY_CURRENCY_MAP[currency],
      action,
      planSelected: installmentsCount,
    });
    onClose();
  };

  return (
    <Dialog
      isShow={isShow}
      onClose={() => close('inactive zone')}
      onCloseAfter={onCloseAfter}
    >
      <LearnMoreContainer>
        <NonStandartLearnMore
          onContinue={() => close('continue')}
          onClose={() => close('cross')}
        />
      </LearnMoreContainer>
    </Dialog>
  );
};
